import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2, TextField, Typography } from '@mui/material';
import React from 'react';
import { ProjectBudgetDTO } from '../../Api/ApiServer';

export interface BudgetItemDescriptionDialogProps {
    onClose: () => void;
    open: boolean;
    budgetItem: ProjectBudgetDTO | null;
    onSave: (budgetItem: ProjectBudgetDTO) => void;
    readOnly?: boolean;
}

export default function BudgetItemDescriptionDialog(props: BudgetItemDescriptionDialogProps) {
    const { onClose, open, budgetItem, onSave, readOnly } = props;
    const [description, setDescription] = React.useState<string>('');
    const [contractDescription, setContractDescription] = React.useState<string>('');

    React.useEffect(() => {
        if (budgetItem) {
            setDescription(budgetItem.description ?? '');
            setContractDescription(budgetItem.contractDescription ?? '');
        }
    }, [budgetItem]);

    const handleSave = () => {
        if (budgetItem) {
            const updatedItem = new ProjectBudgetDTO({
                ...budgetItem,
                description,
                contractDescription
            });
            onSave(updatedItem);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            onClose={handleClose}
            aria-labelledby="budget-item-description-dialog-title"
        >
            <DialogTitle id="budget-item-description-dialog-title">
                <Typography variant="h5" component="span">
                    {budgetItem?.itemName ?? 'Detail položky'}
                </Typography>
                {budgetItem?.itemCode && (
                    <Typography variant="body2" color="text.secondary">
                        Kód: {budgetItem.itemCode}
                    </Typography>
                )}
            </DialogTitle>
            <DialogContent dividers>
                <Grid2 container spacing={3}>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            fullWidth
                            label="Popis"
                            multiline
                            minRows={3}
                            maxRows={8}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            variant="outlined"
                            disabled={readOnly}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            fullWidth
                            label="Popis pro smlouvu"
                            multiline
                            minRows={3}
                            maxRows={8}
                            value={contractDescription}
                            onChange={(e) => setContractDescription(e.target.value)}
                            variant="outlined"
                            disabled={readOnly}
                        />
                    </Grid2>
                </Grid2>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    Zavřít
                </Button>
                {!readOnly && (
                    <Button onClick={handleSave} variant="contained" color="primary">
                        Uložit
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
